"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ReferrerType;
(function (ReferrerType) {
    ReferrerType["TRACK_SUBMIT_BANNER"] = "SUBMIT";
    ReferrerType["TRACK_CLOSE_BANNER"] = "CLOSE";
})(ReferrerType = exports.ReferrerType || (exports.ReferrerType = {}));
//# sourceMappingURL=referrer-type.js.map